module.exports = __webpack_public_path__ + "static/yoga-4603b0c20ba29d7ea988c3be5060e196.jpg";